import styled, { css } from 'styled-components';

const Main = styled.div`
  width: 100%;
  height: 100%;
`;

const Grid = styled.div`
  display: grid;
  grid-gap: ${({ gap }) => gap}px;
  ${({ column }) =>
    column &&
    column > 0 &&
    css`
      grid-template-columns: repeat(${column}, minmax(0, 1fr));
    `}

  ${({ cssExt }) => cssExt && cssExt}
`;

export default function GridLayout({ children, column = 1, gap = 6, cssExt }) {
  return (
    <Main>
      <Grid column={column} gap={gap} cssExt={cssExt}>
        {children}
      </Grid>
    </Main>
  );
}
